import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PaymentOptions } from "../../../components/Accounts/Account/Utlis";
import Report from "../../../components/Accounts/Reports/report";
import { RawItemsAutoComplete } from "../../../components/AutoComplete/RawItems";
import {
  VoucherItem,
  VoucherItemType,
  VoucherType,
  createAccountVoucher,
} from "../../../utils/vouchers/vouchersHelper";
import BillDetailsModal from "./BillDetailsModal";

export const CreateBillModal = ({ open, onClose, supplier }) => {
  const dispatch = useDispatch();
  const [voucherPrintData, setVoucherPrintData] = useState({});

  const product = useSelector((state) => state.products.products);
  const initialValues = {
    selectedProduct: "",
    useType: "",
    useDetail: "",
    otherUseQuantity: "",
  };
  const [values, setValues] = useState(initialValues);
  const [quantity, setQuantity] = useState();
  const [price, setPrice] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [returnTableList, setReturnTableList] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [itemsOptions, setItemsOptions] = useState([]);
  const [totalBill, setTotalBill] = useState(0);
  const [payable, setPayable] = useState(0);
  const [amountPaid, setAmountPaid] = useState("");
  const [grantTotal, setGrantTotal] = useState(0);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const handleOpen = () => setOpenNew(true);

  const handleClose = () => {
    setVoucherPrintData({});
    setOpenNew(false);
  };
  const paymentModeOptions = Object.keys(PaymentOptions).map((key) => ({
    value: PaymentOptions[key],
    label: key,
  }));

  const [selectedPaymentMode, setSelectedPaymentMode] = useState(
    paymentModeOptions[0]
  );

  useEffect(() => {
    if (open) {
      setReturnTableList([]);
      setSelectedItem(null);
      setQuantity();
      setPrice("");
      setTotalBill(0);
      setPayable(0);
      setAmountPaid("");
      setBillDetails(null);
      setGrantTotal(0);
    }
  }, [open]);

  useEffect(() => {
    calculateTotalSum(returnTableList);
  }, [returnTableList, payable]);

  const supplierOption = useMemo(() => {
    return supplier.map((el) => ({
      label: el.name,
      value: el.id,
      items: el.items || [],
      payable: el.payable,
    }));
  }, [supplier]);

  console.log(supplierOption);

  const handleSupplier = (event, newValue) => {
    setSelectedSupplier(newValue);
    if (newValue) {
      setItemsOptions(newValue.items || []);
      setReturnTableList([]); // Clear table when supplier changes
      setPayable(newValue.payable || 0); // Set the payable state
    } else {
      setItemsOptions([]);
      setReturnTableList([]); // Clear table when no supplier selected
      setPayable(0); // Reset payable state
    }
  };

  const AddItemsInTable = () => {
    if (selectedItem && quantity > 0 && price) {
      let cleanedPrice = parseFloat(price.replace(/,/g, ""));
      if (isNaN(cleanedPrice)) {
        console.log("Invalid price format");
        return;
      }

      const totalAmount = Math.round(cleanedPrice * quantity);
      console.log(selectedItem);

      const newRow = {
        id: selectedItem.id,
        quantity: quantity,
        price: cleanedPrice,
        totalAmount: totalAmount,
        name: selectedItem.name || "No Name", // Ensure the name is added
      };

      const updatedList = [...returnTableList, newRow];
      setReturnTableList(updatedList);
    } else {
      console.log("Selected item is not valid or quantity/price is missing.");
    }
  };

  const calculateTotalSum = (list) => {
    const returnAmount = list.reduce(
      (sum, item) => sum + (item.totalAmount || 0),
      0
    );
    setTotalBill(returnAmount);
    setGrantTotal(returnAmount + Number(payable));
  };

  const handleDelete = (index) => {
    const updatedList = returnTableList.filter((_, i) => i !== index);
    setReturnTableList(updatedList);
  };

  const handleEdit = (index) => {
    const itemToEdit = returnTableList[index];
    setSelectedItem({ label: itemToEdit.name, value: itemToEdit.id });
    setQuantity(itemToEdit.quantity);
    setPrice(itemToEdit.price.toString());
    handleDelete(index); // Remove the item from the table to allow re-adding it with updated values
  };

  const handleSubtract = async () => {
    if (amountPaid === "" || parseInt(amountPaid) < 0) {
      alert("Please provide payment info");
      return;
    }

    setLoading(true); // Start loading

    try {
      const data = {
        supplierId: selectedSupplier ? selectedSupplier.value : null,
        items: returnTableList,
        totalBill: totalBill,
        paymentMode: selectedPaymentMode,
        amountPaid: amountPaid,
      };
      let type =
        selectedPaymentMode.value === PaymentOptions.Cash
          ? VoucherType.cashPayment
          : VoucherType.bankPayment;
      console.log(data, type, selectedSupplier.value);
      let amountToAdjust = totalBill - amountPaid;

      let voucherItems = [
        new VoucherItem({
          transaction: VoucherItemType.debit,
          amount: totalBill + "",
          code: selectedSupplier.value,
          particular: selectedSupplier.label,
          description: "Supplier Bill",
          type,
        }),
        
        new VoucherItem({
          transaction: VoucherItemType.credit,
          amount: amountPaid + "",
          code:
            selectedPaymentMode.value === PaymentOptions.Cash
              ? "07-001-0001"
              : "07-002-0001",
          particular:
            selectedPaymentMode.value === PaymentOptions.Cash
              ? "Cash Payment"
              : "Bank Payment",
          description: "bill paid to supplier",
          type,
        }),
      ]
      // if (amountToAdjust !== 0) {
      //   voucherItems.push(
      //     new VoucherItem({
      //       transaction: VoucherItemType.credit,
      //       amount: amountToAdjust + "",
      //       code: selectedSupplier.value,
      //       particular: selectedSupplier.label,
      //       description: "Supplier Bill",
      //       type,
      //     })
      //   );
      // }
      
      await createAccountVoucher(type,voucherItems );

      // Update the payable in the Redux store
      const newPayable = grantTotal - amountPaid;
      // dispatch(updatePayable({ id: selectedSupplier.value, newPayable }));

      // Prepare bill details and open details modal
      const date = new Date();
      const dateString = date.toLocaleDateString();
      const timeString = date.toLocaleTimeString();
      // for voucher //
      let voucherObject = {
        id: "617fb229f661460020535df3",
        invoice: [
          {
            transaction: VoucherItemType.credit,
            debit: "",
            credit: amountPaid,
            amount: amountPaid,
            code:
              selectedPaymentMode.value === PaymentOptions.Cash
                ? "07-001-0001"
                : "07-002-0001",
            particular:
              selectedPaymentMode.value === PaymentOptions.Cash
                ? "Cash Payment"
                : "Bank Payment",
            Discription: "bill paid to supplier",
            cheque: "",
            billno: "",
            transactionType: VoucherItemType.credit,
            type: type,
            id: "1",
            site: "1",
            voucherDate: new Date().toLocaleDateString(),
            voucherUTCDate: {
              _seconds: 1729517393,
              _nanoseconds: 976000000,
            },
            voucherNumber: 33,
          },
          {
            transaction: VoucherItemType.debit,
            debit: totalBill,
            credit: "",
            amount: totalBill + "",
            code: selectedSupplier.value,
            particular: selectedSupplier.label,
            description: "Supplier Bill",
            Discription: "Supplier Bill",
            cheque: "",
            billno: "",
            transactionType: VoucherItemType.debit,
            type: type,
            id: "1",
            site: "1",
            voucherDate: new Date().toLocaleDateString(),
            voucherUTCDate: {
              _seconds: 1729517393,
              _nanoseconds: 975000000,
            },
            voucherNumber: 33,
          },
        ],
        titleData: {
          site: "New Site",
          title: "Voucher",
          subTitle: "Date: " + new Date().toLocaleDateString(),
          leftTitle: "",
          leftSubTitle: "",
          rightTitle: "",
          rightSubTitle: "",
        },
        subTitleData: {
          type: type,
          number: 33,
          description: "",
        },
        docTitle: "",
        docType: "Voucher",
        from: "",
        to: "",
        codeDetails: {},
        totalDebit: totalBill,
        totalCredit: amountPaid,
        balance: 0,
        openingBalance: 0,
      };
      setVoucherPrintData(voucherObject);
      handleOpen();
      // setBillDetails({
      //   supplierName: selectedSupplier ? selectedSupplier.label : "Undefined",
      //   date: dateString,
      //   time: timeString,
      //   returnTableList: returnTableList,
      //   totalBill: totalBill,
      //   amountPaid: amountPaid,
      //   paymentMode: selectedPaymentMode.label,
      //   payable: payable,
      //   grantTotal: grantTotal,
      // });

      // setDetailsModalOpen(true);
      // toast.success("Bill Created Successfully");
    } catch (error) {
      console.error("Failed to create bill", error);
      toast.error("Failed to create bill");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleSubtractClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleSubtractClose}>
        <form>
          <DialogContent>
            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="200px"
              >
                <CircularProgress />
              </Box>
            ) : (
              <Stack spacing={1}>
                <Stack spacing={1}>
                  <Autocomplete
                    options={supplierOption}
                    value={selectedSupplier}
                    onChange={handleSupplier}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Supplier" />
                    )}
                  />
                  <RawItemsAutoComplete
                    value={selectedItem}
                    onChange={(event, newValue) => setSelectedItem(newValue)}
                  />
                </Stack>
                <Stack direction="row" spacing={2}>
                  <TextField
                    size="small"
                    type="number"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    label="Quantity"
                    fullWidth
                  />
                  <TextField
                    size="small"
                    type="text"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    label="Price"
                    fullWidth
                  />
                </Stack>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={AddItemsInTable}
                >
                  Add
                </Button>
                <Table sx={{ width: "100%", overflowX: "auto" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Total Amount</TableCell>
                      <TableCell>Actions</TableCell>{" "}
                      {/* New column for actions */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {returnTableList.length > 2 ? (
                      <TableRow>
                        <TableCell
                          colSpan={5}
                          style={{ overflowY: "auto", maxHeight: 100 }}
                        >
                          <Table size="small">
                            <TableBody>
                              {returnTableList.map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell>{item.name}</TableCell>
                                  <TableCell>{item.quantity}</TableCell>
                                  <TableCell>{item.price}</TableCell>
                                  <TableCell>{item.totalAmount}</TableCell>
                                  <TableCell>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleEdit(index)}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDelete(index)}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableCell>
                      </TableRow>
                    ) : (
                      returnTableList.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.quantity}</TableCell>
                          <TableCell>{item.price}</TableCell>
                          <TableCell>{item.totalAmount}</TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(index)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
                <Stack
                  spacing={1}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  bgcolor={"lightgray"}
                >
                  <Typography>Bill: {totalBill}</Typography>
                  <Typography>Arrear: {payable}</Typography>
                  <Typography fontWeight={"bold"}>
                    Today Total: {grantTotal}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={2}>
                  <TextField
                    size="small"
                    type="number"
                    value={amountPaid}
                    onChange={(e) => setAmountPaid(e.target.value)}
                    label="Amount Paid"
                    fullWidth
                  />
                  <Autocomplete
                    options={paymentModeOptions}
                    value={selectedPaymentMode}
                    onChange={(event, newValue) =>
                      setSelectedPaymentMode(newValue)
                    }
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField {...params} label="Payment Mode" />
                    )}
                    size="small"
                    fullWidth
                  />
                </Stack>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubtract}
                >
                  Create Bill
                </Button>
              </Stack>
            )}
          </DialogContent>
        </form>
      </Dialog>
      {detailsModalOpen && (
        <BillDetailsModal
          open={detailsModalOpen}
          onClose={() => setDetailsModalOpen(false)}
          billDetails={billDetails}
        />
      )}
      <Report
        open={openNew}
        handleClose={handleClose}
        data={voucherPrintData}
      />
    </>
  );
};
